import { api } from 'api'

// NOTE: these types differ from the ones in common_defs.ts slightly
// since new position templates to groups are many-to-many
export interface PositionTemplateGroup {
  id: number
  name: string
}

export interface PositionTemplate {
  id: number
  name: string
  relevantPositionTemplateGroups: PositionTemplateGroup[]
}

export async function getPositionTemplates(companyId: number) {
  const response = await api.get<{ positionTemplates: PositionTemplate[] }>(
    `/company/${companyId}/position/templates`,
    {}
  )

  return response.data.positionTemplates
}
